import {useState} from "react";

export function useRerender() {
    const [, update] = useState(null);
    return ()=>update([]);
}
